<h2 style="background: var(--ion-color-secondary-shade) !important;color: white;" mat-dialog-title>  Import Calling Contact</h2>
<mat-dialog-content style="padding: 5px !important;">
  <!-- <ion-item> -->
  <!-- <input style="white-space: normal;" type="file" accept=".xls,.xlsx" (change)="onFileSelected($event)" /> -->
  <input #fileInput type="file" accept=".xls,.xlsx" (change)="onFileSelected($event)" style="display: none;" />
  <ion-button style="padding: 0px !important; " (click)="fileInput.click()">
    <ion-icon name="cloud-upload-outline" slot="start"></ion-icon>
    Select Excel File
  </ion-button><br>
  @if (selectedFileName) {
  <ion-text style="margin-left: 10px;">
    {{ selectedFileName }}
  </ion-text>
  }
  <!-- </ion-item> -->
</mat-dialog-content>
<ion-row>
  <ion-col size="12" class="ion-no-padding col-button">
    <ion-button class="cancel-btn" (click)="cancel()">
      <ion-text>Close</ion-text>
    </ion-button>
    <ion-button [disabled]="!file" (click)="uploadExcel()">
      <ion-text>Upload</ion-text>
    </ion-button>
  </ion-col>
</ion-row>